import addToCart from './addToCart';
import pageView from './pageView';
var events = {
  'addtocart:success': [addToCart],
  pageview: [pageView]
};
export default events;